import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import DataTable from "../../Table/DataTable";
import { openRightModal } from "../../../REDUX/actions/rightModal";
import { deleteDepot, fetchDepots } from "../../../REDUX/actions/depot";
import VerticalPoints from "../../Common/VerticalPoints/VerticalPoints";
import { openCenteredModal } from "../../../REDUX/actions/centeredModal";
import ConfirmModal from "../../Common/Modal/ConfirmModal";
import DepotModal from "../DepotModal";

const DepotTable = () => {
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const { depots, loading, pageCount, total } = useSelector(
    (state) => state.depotReducer,
  );

  const fetchData = (page, search, filters, signal) => {
    dispatch(fetchDepots(page, search, filters, signal));
  };

  const headers = ["Name", "Code", "Email", "Phone", "Address", "Storekeepers"];

  const columns = [
    {
      name: "Name",
      render: (row) => row?.attributes?.name ?? "-",
    },
    {
      name: "Code",
      render: (row) => row?.attributes?.code ?? "-",
    },
    {
      name: "Email",
      render: (row) => row?.attributes?.email ?? "-",
    },
    {
      name: "Phone",
      render: (row) => row?.attributes?.phone ?? "-",
    },
    {
      name: "Address",
      render: (row) => {
        const address = row?.attributes?.address?.data?.attributes;
        if (!address) return "-";
        return (
          `${address.street || ""} ${
            address.city?.data?.attributes?.name || ""
          } ${address?.city?.data?.attributes?.zipCode || ""}`.trim() || "-"
        );
      },
    },
    {
      name: "Storekeepers",
      render: (row) => {
        const storekeepers = row?.attributes?.storekeepers?.data;
        if (!storekeepers || storekeepers.length === 0) return "0";
        return storekeepers.length.toString();
      },
    },
  ];

  headers.push("");
  columns.push({
    name: "options",
    render: (row) => {
      return (
        <VerticalPoints
          showLeft
          className="ms-auto"
          options={[
            {
              text: t("Edit"),
              callback: () =>
                dispatch(openRightModal(<DepotModal id={row?.id} />)),
            },
            {
              text: t("Delete"),
              callback: () =>
                dispatch(
                  openCenteredModal(
                    <ConfirmModal
                      id={row?.id}
                      label={t("Depot")}
                      onConfirm={() => dispatch(deleteDepot(row?.id, t))}
                    />,
                  ),
                ),
            },
          ]}
        />
      );
    },
  });

  return (
    <div>
      <DataTable
        showRowDetails={false}
        newItemTitle={t("Add a depot")}
        title={t("Depots")}
        headers={headers}
        columns={columns}
        fetchData={fetchData}
        totalPages={pageCount}
        data={depots}
        loading={loading}
        total={total}
        noResultsMessage="No results found"
        addNewItem={() => dispatch(openRightModal(<DepotModal />))}
        onRowClick={(id) => dispatch(openRightModal(<DepotModal id={id} />))}
      />
    </div>
  );
};

export default DepotTable;
